import type { PathStep } from '~/pages/backoffice/admin/sessions/path-step'
import { ScoreRetention } from '@zeus/index'
import { useTranslation } from 'react-i18next'

type IProps = {
  step: PathStep
  onChange: (next: Pick<PathStep, 'allowRetake' | 'scoreRetention'>) => void
}

/** Libellé de chaque règle de score retenu. */
const RETENTION_KEYS: Record<ScoreRetention, string> = {
  [ScoreRetention.BEST]: 'sessions.path.retention.BEST',
  [ScoreRetention.LAST]: 'sessions.path.retention.LAST',
  [ScoreRetention.AVERAGE]: 'sessions.path.retention.AVERAGE',
}

/**
 * Refaire le module une fois terminé, et le score retenu dans ce cas (#84).
 *
 * Le score retenu n'est proposé que si l'on peut refaire : avec une seule
 * tentative, meilleur, dernier et moyenne disent la même chose.
 */
function RetakeFields({ step, onChange }: IProps) {
  const { t } = useTranslation()
  const id = `retention-${step.moduleId}`

  return (
    <div className="flex w-full flex-wrap items-center gap-x-3 gap-y-1.5 pl-9 text-xs text-muted-foreground">
      <label className="flex items-center gap-1.5">
        <input
          type="checkbox"
          checked={step.allowRetake}
          onChange={event => onChange({ allowRetake: event.target.checked, scoreRetention: step.scoreRetention })}
        />
        {t('sessions.path.retake.allow')}
      </label>

      {step.allowRetake && (
        <>
          <label htmlFor={id}>{t('sessions.path.retention')}</label>
          <select
            id={id}
            value={step.scoreRetention}
            onChange={event => onChange({ allowRetake: true, scoreRetention: event.target.value as ScoreRetention })}
            className="h-7 rounded-md border border-input bg-transparent px-2 text-xs text-foreground"
          >
            {Object.entries(RETENTION_KEYS).map(([value, key]) => (
              <option key={value} value={value}>{t(key)}</option>
            ))}
          </select>
        </>
      )}
    </div>
  )
}

export default RetakeFields
